<template>
  <v-card>
    <v-container>
      <v-layout row wrap>
        <v-flex xs12 class="headline">Delete {{deleteSubject}}?</v-flex>
        <v-flex>
          <v-switch
            :color="this.primaryNeutral"
            v-model="deleteDocket"
            label="Also delete docket and related trips?"
          ></v-switch>
        </v-flex>
      </v-layout>
    </v-container>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn flat @click="close()" :color="primaryGrey">Close</v-btn>
      <v-btn
        flat
        @click="deleteTripDocket()"
        color="red darken-1"
        :loading="loading"
      >Delete {{deleteSubject}}</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import DocketService from "@/services/requests/docketService";
export default {
  data() {
    return {
      loading: false,
      deleteDocket: false
    };
  },
  computed: {
    deleteSubject() {
      if (this.deleteDocket) {
        return "Docket";
      }
      return "Trip";
    }
  },
  methods: {
    close() {
      this.$emit("close");
    },
    deleteTripDocket() {
      this.loading = true;
      if (this.deleteDocket) {
        DocketService.deleteDocket(this.trip.docket.id).then(result => {
          for (var trip of result.data.result.deletedTrips) {
            this.$store.commit("trips/deleteFromArrayStateById", {
              prop: "trips",
              id: trip
            });
          }
          this.loading = false;
          this.snack({
            color: "blue",
            text: `Deleted 1 docket and ${result.data.result.deletedTrips.length} trips`
          });
          this.close();
        });
      } else {
        DocketService.deleteTrip(this.trip.id).then(result => {
          this.$store.commit("trips/deleteFromArrayStateByValue", {
            prop: "trips",
            value: this.trip
          });
          this.loading = false;
          this.close();
        });
      }
    }
  },
  props: {
    trip: Object
  }
};
</script>

<style>
</style>
